import axios from "axios";
import {estimateServicesPath} from "../../../Constants";

const packagingUnitRestUrl = estimateServicesPath + '/packaging-units'
const packagingUnitSetRestUrl = estimateServicesPath + '/packaging-units-set'

export default class PackagingUnitService {

    static async getAll() {
        return axios.get(packagingUnitRestUrl);
    }

    static async getAllByPackagingSetId(id) {
        return axios.get(packagingUnitSetRestUrl + '/packaging-sets/' + id);
    }

    static async updatePackagingSet(id, data) {
        console.log(id, data)
        return await axios.patch(packagingUnitSetRestUrl + '/' + +id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(id, data) {
        await axios.post(packagingUnitRestUrl + '/' + +id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(data) {
        return await axios.post(packagingUnitRestUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(packagingUnitRestUrl + '/' + id);
    }
}